import * as Sentry from "@sentry/react";
import { setSentryUserContext } from "@/config/sentry.config";

interface CaptureCustomEventOptions {
  message: string;
  threadId?: string | number;
  level?: Sentry.SeverityLevel;
  extra?: Record<string, any>;
}

/**
 * Capture a custom event in Sentry with optional threadId context
 * This will be formatted as: CUSTOM: <userId> | <companyId> | <threadId>: <message>
 */
export const captureCustomSentryEvent = ({
  message,
  threadId,
  level = "info",
  extra,
}: CaptureCustomEventOptions) => {
  // Temporarily set threadId if provided
  if (threadId) {
    setSentryUserContext({ threadId });
  }

  Sentry.captureMessage(message, {
    level,
    tags: {
      custom: true,
    },
    extra,
  });
};

/**
 * Capture an exception in Sentry with optional threadId context
 * This will be formatted as: ERROR: <userId> | <companyId>: <error message>
 */
export const captureCustomSentryException = (
  error: Error,
  threadId?: string | number,
  extra?: Record<string, any>
) => {
  if (threadId) {
    setSentryUserContext({ threadId });
  }

  Sentry.captureException(error, {
    extra,
  });
};
